/* eslint-disable react/no-danger */
/* eslint-disable @typescript-eslint/naming-convention */
import { FC, useEffect, useMemo, useState } from 'react'
import { ProductDescription, ProductExpQuantity } from 'modules/products/components'
import { SellerInline } from 'modules/sellers/components'
import { Button, Carousel } from 'components/ui'
import { Exp } from 'framework/products'
import { numberToCurrency } from 'helpers/currency'
import { Clock, Dog, LocationArrow } from 'components/icons'
import { useCart } from 'hooks/use-cart'
import { useNotification } from 'hooks/use-notification'
import { CartProduct } from 'framework/cart'
import s from './product-event-view.module.css'
import type { ProductEventViewProps } from '.'

interface Item {
  id: string
  isAtacado: boolean
  price: number
  quantity?: number
  period?: string
  itemTotal?: number
  type: 'convencional' | 'experiencia'
  delivery_method: string,
  [key: string]: any,
}

const resp = {
  wide: {
    items: 3.5,
    partialVisibilityGutter: 0,
  },
  desktop: {
    items: 3.5,
    partialVisibilityGutter: 0,
  },
  tablet: {
    items: 3,
    partialVisibilityGutter: 0,
  },
  mobile: {
    items: 2.2,
    partialVisibilityGutter: 0,
  },
}

const Ticket = ({ exp, add }: { exp: Exp; add: (exp: Exp, quantity: number) => void }) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { horario, data_evento, preco, descricao } = exp
  const [quantity, setQuantity] = useState<number>(0)

  function changeQuantity({ next }: { next: number }) {
    setQuantity(next)
  }

  useEffect(() => {
    add(exp, quantity)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantity])

  const pad = '00'
  const dateParser = `${data_evento}T00:00:00-03:00`
  const date = new Date(dateParser)
  const dayInt = date.getDate().toString()
  const day = pad.substring(0, pad.length - dayInt.length) + dayInt
  const m = (date.getMonth() + 1).toString()
  const month = pad.substring(0, pad.length - m.length) + m
  const year = date.getFullYear()

  return (
    <div className={s.ticket}>
      <div className={s.ticketInfo}>
        <div className={s.ticketDate}>
          {day}/{month}/{year}&nbsp;
          <Clock width={14} />
          &nbsp;{horario}
        </div>
        <div className={s.ticketDescription}>
          <div>{descricao}</div>
          <div className={s.ticketPrice}>R$ {numberToCurrency(parseFloat(preco))}</div>
        </div>
      </div>
      <ProductExpQuantity canChange onChange={changeQuantity} quantity={quantity} dropdown={false} maximum={50} />
    </div>
  )
}
const ProductEventView: FC<ProductEventViewProps> = ({ product }) => {
  const {
    image,
    slug,
    images,
    name,
    description,
    experiencia_aceita_animais,
    experiencia_entrada,
    experiencia_prato_principal,
    experiencia_bebidas,
    experiencia_sobremesa,
    experiencia_localizacao,
    experiencia_transporte,
    seller,
    experiencias,
  } = product

  const [expDescricao, setExpDescricao] = useState<string>(null as unknown as string)
  const [expEntrada, setExpEntrada] = useState<string>(null as unknown as string)
  const [expPratoPrincipal, setExpPratoPrincipal] = useState<string>(null as unknown as string)
  const [expSobremesa, setExpSobremesa] = useState<string>(null as unknown as string)
  const [expBebidas, setExpBebidas] = useState<string>(null as unknown as string)

  const [collection, setCollection] = useState<Exp[]>(product.experiencias)
  const [price, setPrice] = useState<number>(0)
  const { addItem } = useCart()
  const { notify } = useNotification()

  const imagesSet = !image || image === '' ? images : [{ url: image }, ...images]

  useEffect(() => {
    setExpEntrada(experiencia_entrada as unknown as string)
    setExpPratoPrincipal(experiencia_prato_principal as unknown as string)
    setExpSobremesa(experiencia_sobremesa as unknown as string)
    setExpBebidas(experiencia_bebidas as unknown as string)
    setExpDescricao(description)
  }, [])

  function update(exp: Exp, quantity: number) {
    const data = collection.map((e: Exp) => {
      if (e.id === exp.id) {
        e.quantidade = quantity
        // @ts-ignore
        e.total = quantity * parseFloat(e.preco)
      }

      return e
    })

    // @ts-ignore
    const x = [...data]
    let amount: number = 0
    // eslint-disable-next-line func-names
    x.forEach(function ({ total }: Exp) {
      amount += total || 0
    })

    setCollection(x)
    setPrice(amount)
  }

  function buy() {
    if (price <= 0) {
      notify({
        title: 'Selecione ao menos um ingresso',
        description: 'aumente a quantidade do ingresso que quer comprar',
        type: 'warning',
      })
      return
    }

    let qtd = 0
    // eslint-disable-next-line array-callback-return
    collection.forEach((exp: Exp) => {
      if (exp.quantidade > 0) {
        const pad = '00';
        const dateParser = `${exp.data_evento}T00:00:00-03:00`;
        const date = new Date(dateParser);
        const dayInt = date.getDate().toString();
        const day = pad.substring(0, pad.length - dayInt.length) + dayInt;
        const m = (date.getMonth() + 1).toString();
        const month = pad.substring(0, pad.length - m.length) + m;
        const year = date.getFullYear();

        const item: Item = {
          id: exp.produto_id.toString(),
          experiencia_id: exp.id,
          isAtacado: false,
          price: parseFloat(exp.preco),
          type: 'experiencia',
          delivery_method: 'retirada-local',
          name: `${name} | ${exp.descricao} | ${day}/${month}/${year} ${exp.horario}`,
          slug,
          imageUrl: image,
          assinatura: false,
          quantity: exp.quantidade,
          itemTotal: parseFloat(exp.preco) * exp.quantidade,
          lastChange: new Date(),
          seller: product.seller,
        };

        addItem(item, exp.quantidade);

        qtd += exp.quantidade;
      }
    });

    notify({ title: 'Adicionado ao carrinho', description: `${qtd}x ${product.name}`, type: 'success' })
  }

  const localizacao = useMemo(() => {
    if (experiencia_localizacao && experiencia_localizacao.length > 0) {
      const xxx = experiencia_localizacao || ''
      const str2 = xxx.split(' ').join('+')
      return str2
    }

    return null
  }, [experiencia_localizacao])

  return (
    <div className={s.root}>
      <header>
        <h1 className={s.title}>{name}</h1>
        <SellerInline {...seller} pre="Anfitrião" className={s.seller} />
      </header>
      <Carousel config={resp} ssr className={s.gallery}>
        {imagesSet.map(({ url }) => (
          <div className={s.image}>
            <img src={url} alt="" />
          </div>
        ))}
      </Carousel>
      <div className={s.content}>
        <div className={s.description}>
          <div className={s.section}>
            <h3>Descrição</h3>
            <ProductDescription description={expDescricao} />
          </div>
          <div className={s.food}>
            {experiencia_entrada && (
              <div className={s.section}>
                <h3>Entrada</h3>
                <p dangerouslySetInnerHTML={{ __html: expEntrada }} />
              </div>
            )}

            {experiencia_prato_principal && (
              <div className={s.section}>
                <h3>Prato principal</h3>
                <p dangerouslySetInnerHTML={{ __html: expPratoPrincipal }} />
              </div>
            )}

            {experiencia_sobremesa && (
              <div className={s.section}>
                <h3>Sobremesa</h3>
                <p dangerouslySetInnerHTML={{ __html: expSobremesa }} />
              </div>
            )}

            {experiencia_bebidas && (
              <div className={s.section}>
                <h3>Bebidas</h3>
                <p dangerouslySetInnerHTML={{ __html: expBebidas }} />
              </div>
            )}
          </div>

          {experiencia_aceita_animais && experiencia_aceita_animais === 'sim' && (
            <div className={s.line}>
              <Dog /> <span>Aceita animais</span>
            </div>
          )}

          {experiencia_transporte && (
            <div className={s.line}>
              <LocationArrow />
              <span dangerouslySetInnerHTML={{ __html: experiencia_transporte }} />
            </div>
          )}
        </div>
        <aside className={s.aside}>
          {experiencias.map((exp) => (
            <Ticket exp={exp} add={update} />
          ))}
          <div className={s.ticketFinalPrice}>
            <div className={s.ticketFinalPriceTotal}>Total</div>
            <div>
              <strong>R$ {numberToCurrency(price)}</strong>
            </div>
          </div>
          <hr />
          <Button variant="primary" width="100%" onClick={buy}>
            Comprar
          </Button>
        </aside>
      </div>
      {localizacao && (
        <iframe
          title="Endereço"
          className={s.iframe}
          src={`https://maps.google.com/maps?q=${localizacao}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
        />
      )}
    </div>
  )
}

export default ProductEventView
